import { useRef } from "react";

// Every write to one row's decisions goes through one lane. The Ownership cells
// write per pick, the panel autosaves the rest a second after an edit, and Promote
// / Save / Reject write the whole row - so two of them a moment apart are concurrent
// PATCHes to the same row, and what persists is whichever the server happened to
// handle last. Serialised, the operator's last action is the last write.
//
// Shared by /leads and /leads/search rather than one lane per page: the search page
// had none, so its autosave and its Promote could overlap.
export const useLeadWriteLane = (): (<T>(
  write: () => Promise<T>
) => Promise<T>) => {
  const chainRef = useRef<Promise<unknown>>(Promise.resolve());
  return <T>(write: () => Promise<T>): Promise<T> => {
    const next = chainRef.current.then(write, write);
    // Swallowed on the LANE only, so one failed write doesn't reject every write
    // queued behind it; the returned promise still carries the failure to the caller.
    chainRef.current = next.catch(() => {});
    return next;
  };
};
